const globalUserTypes = ['owner', 'support', 'warehouse'];

function isGlobalUserType(value) {
  return globalUserTypes.includes(value);
}

export { isGlobalUserType };
